import Head from 'next/head';
import Slider from 'react-slick';
import ReactGA from 'react-ga';
import { useEffect } from 'react';
import { useRouter } from "next/router";
import Layout from '../../components/Layout';
import axiosInstance from '../..//config/axios';
import sanitize from '../../helpers/sanitize';

const About = ({ about_banner, about_content, about_gallery }) => {
	

	useEffect(() => {
		ReactGA.pageview(window.location.pathname + window.location.search);
	}, []);

	
	const banner = about_banner?.includes(' ') ? about_banner?.replaceAll(' ', '%20') : about_banner;
	//const sanitize = (html) => DOMPurify.sanitize(html ?? "");
	const settings = {
		autoplay: true,
		speed: 1000,
		autoplaySpeed: 3000,
		centerMode: true,
		centerPadding: '100px',
		slidesToShow: 3,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					arrows: false,
					centerMode: true,
					centerPadding: '40px',
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 768,
				settings: {
					arrows: false,
					centerMode: true,
					centerPadding: '40px',
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 480,
				settings: {
					arrows: false,
					centerMode: true,
					centerPadding: '40px',
					slidesToShow: 1,
				},
			},
		],
	};

	const createMarkup = (html) => ({ __html: sanitize(html) });
	const router = useRouter();
 const canonicalUrl = `https://kilimanjaro-restaurants.com${router.asPath.split('?')[0]}`;

	return (
		<Layout>
			<Head>
			<link rel="canonical" href={canonicalUrl} />
				<title>About Us Page | Kilimanjaro</title>
				<meta
					name='description'
					content="Kilimanjaro restaurant is a Nigerian restaurant brand owned by Sundry Foods. If you're looking for delicious Nigerian cuisine in a welcoming atmosphere, Kilimanjaro should be at the top of your list. This page tells you more about the restaurant and the delicious African cuisine it offers."
				/>

				<meta name='keyword' content='MEALS FOOD RESTAURANT NIGERIA' />
			</Head>
			{/* <header className="store-header about-us"></header> */}
			<h1 className='visually-hidden'>About Us Page</h1>
			<header className="store-header about-us">
  <img
    src={banner}
    alt="About Us Banner"
    className="img-fluid"
    loading="eager"
    decoding="async"
  />
</header>
			<section className='contact-us store-location about'>
				<div className='container'>
					<div className='row'>
						<div className='col-12 text-center'>
							<h4>About us</h4>
						</div>
						<div className='col-md-10 text-sm-center text-left mx-auto'>
							<div dangerouslySetInnerHTML={createMarkup(about_content)}></div>
							
						</div>
					</div>
					<div className='mt-5 slide-images'>
						<div className='row'>
							<div className='col-12'>
								<Slider {...settings}>
									{about_gallery?.length > 0 &&
										about_gallery?.map((gallery, i) => {
											return <img key={i} className='img-fluid' src={gallery} alt='' />;
										})}
								</Slider>
							</div>
						</div>
					</div>
					<div className="certification-wrapper w-100 d-flex justify-content-center py-5">
  <div className="d-flex flex-column flex-md-row align-items-center ">
    <div className="d-flex flex-column align-items-center mr-md-5">
    <a href="https://drive.google.com/file/d/16vqNBXpP4X2Io-IuI5bpZo5l-gzuxkN7/view?usp=drive_link" target="_blank" rel="noopener noreferrer" className="text-center text-decoration-none" aria-label="View Seal Certificate of Compliance in a new tab">
    <img src="/images/eagle-new.png" className="img-fluid mx-md-4 cert-image"  alt="Eagle image" />
	
	<h6 className="  cert-text">Certificate of <br />Compliance</h6>
    </a>
     
    
    </div>
    <div className="d-flex flex-column align-items-center">
    <a href="https://drive.google.com/file/d/19VLLQjJbOfwyk8FbNRlHHoPD_5fP0NWX/view?usp=drive_link" target="_blank" rel="noopener noreferrer" className="text-center text-decoration-none" aria-label="View Seal Certificate of Compliance in a new tab">
    <img src="/images/seal.png" className="img-fluid mx-md-4 cert-image" alt="Seal image" />
    <h6 className="text-center cert-text ">NDPR Audit  <br />Compliant 2024</h6>
    </a>
      
      
    </div>
  </div>
</div>
				</div>
			</section>
		</Layout>
	);
};

About.getInitialProps = async () => {
	try {
		const {
			data: {
				data: { about_banner, about_content, about_gallery },
			},
		} = await axiosInstance.get('settings');

		return { about_banner, about_content, about_gallery };
	} catch (e) {
		// console.log(e);
		return {};
	}
};

export default About;
